import React, { useState } from 'react';
import MatrimonyHero from "../components/MatrimonyHero";
import MatrimonyHowitWork from "../components/MatrimonyHowItWork";
import MatrimonyHomeHero from "../components/MatrimonyHomeHero";
import Footer from "../components/Footer";
import MatriHeader from "../components/MatriHeader";
import ProfileSlider from "../components/MatrimonyProfile";
import { getProfileListing } from '../utils/api';

function Matrimony() {
  const [searchResults, setSearchResults] = useState([]);

  const handleSearch = async (filters) => {
    try {
      const results = await getProfileListing(filters);
      setSearchResults(results);
    } catch (err) {
      console.error("Search failed:", err);
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <MatriHeader />

      {/* Main content */}
      <main className="flex-1">
        <MatrimonyHomeHero />
        <MatrimonyHero onSearch={handleSearch} />
        <ProfileSlider
          profiles={searchResults.length ? searchResults : null}
          title="All Profiles"
        />
        <MatrimonyHowitWork />
      </main>

      {/* Footer sticks to bottom */}
      <Footer />
    </div>
  );
}

export default Matrimony;